import React from 'react';
import { CustomDialog } from 'components/dialog/CustomDialog';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const ImpressumDialog: React.FC<IProps> = ({ open, onClose }) => (
  <CustomDialog open={open} handleClose={onClose} title="Impressum" maxWidth="md" className="psf-legal-dialog">
    <div className="psf-legal-dialog__body">
      <h5>Sparkassen-Finanzportal GmbH</h5>
      <p>
        Friedrichstraße 50
        <br />
        10117 Berlin
      </p>

      <h5>Handelsregister</h5>
      <p>HRB 91513 B beim Amtsgericht Charlottenburg, Berlin</p>

      <h5>Umsatzsteuer-Identifikationsnummer nach §27 a UStG</h5>
      <p>DE 214 20 50 98</p>

      <h5>Vorsitzende(r) der Geschäftsführung</h5>
      <p>Oliver Lux</p>

      <h5>Mitglied(er) der Geschäftsführung</h5>
      <p>Sebastian Garbe</p>

      <h5>Kontakt</h5>
      <p>
        Telefon: 030 24 636-720
        <br />
        Fax: 030 24 63 67-01
        <br />
        E-Mail: <a href="mailto:sparkasse@sparkassen-finanzportal.de">sparkasse@sparkassen-finanzportal.de</a>
      </p>
    </div>
  </CustomDialog>
);
